var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"brand-signature",class:[
    `brand-signature--${_vm.placement}`,
    `brand-signature--${_vm.theme}`,
    `brand-signature--${_vm.size}`,
    `brand-signature--${_vm.appearance}`,
  ],style:(_vm.brandStyle)},[_c('img',{staticClass:"brand-signature__logo",class:_vm.logoClass,attrs:{"src":_vm.src,"alt":_vm.alt}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"brand-signature__credit",attrs:{"aria-label":"by Anzera"}},[_c('span',{staticClass:"brand-signature__by"},[_vm._v("by")]),_c('span',{staticClass:"brand-signature__anzera"},[_vm._v("Anzera")])])
}]

export { render, staticRenderFns }